import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';

import firstImage from '../../../assets/images/warehouse.png';
import secondImage from '../../../assets/images/information.png';
import Docmnt from '../../../assets/images/google-docs.png';
import Trash from '../../../assets/images/trash.png';
import MailGreen from '../../../assets/images/mail_green.png';
import MailRed from '../../../assets/images/mail_red.png';
import AssetsIcon from '../../../assets/images/oparation.svg';
import AssetsIconw from '../../../assets/images/oparation_a.svg';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tab, Tabs, Modal, Row, Col, Button, Form, Accordion, Table, Dropdown } from 'react-bootstrap';
import { faArrowLeft, faCircleXmark, faPencilAlt, faPaperclip, faFileArrowDown, faFileLines, faEllipsisVertical, faDownload, faPaperPlane, faXmark, faStar } from '@fortawesome/free-solid-svg-icons';
import { Step, StepLabel, Stepper } from '@mui/material';
import Select from 'react-select'
import { toast } from 'react-toastify';
import Pack from '../../../assets/images/n_package.png';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { GETAGENT, GETDESTINATION, GETOWNERCODE, RECOVERYDETAILS, SAVEHANDLER, SAVERECOVERY, SROPENCLOSE, STATIONHANDLER, STATIONLIST, ULDADDRESSSAVE } from '../../../Utils/conts.js';
import { saveAs } from "file-saver";
import Uploadw from '../../../assets/images/upload-w.png';
import Radown from "../../../assets/images/radown.png";
import Shipupload from "../../../assets/images/ship_upload.png";
import msg_icon from "../../../assets/images/recovery_inbox/msg_icon.png";
import msg_icon_hover from "../../../assets/images/recovery_inbox/msg_icon_hover.png";
import setting from "../../../assets/images/recovery_inbox/setting.png";
import gallary from "../../../assets/images/recovery_inbox/gallary.png";
import send_icon from "../../../assets/images/recovery_inbox/send_icon.png";
import attach from "../../../assets/images/recovery_inbox/attach.png";
import compose_mail from "../../../assets/images/recovery_inbox/compose_mail.png";
// import TaskManagement from './common/TaskManagement.js';
// import DocManagement from './common/DocManagement.js';
// import Invoice from './common/Invoice.js';
import Attachment from './common/Attachments.js';
import Message from './common/Messages.js';

const AddRecovery = () => {

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [originHandler, setOriginHandler] = useState([]);
    const [selectedOriginId, setSelectedOriginId] = useState(null);
    const [selectedOriginHandler, setSelectedOriginHandler] = useState(null);
    const [getDestination, setGetDestination] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [destinationHandler, setDestinationHandler] = useState([]);
    const [selectedDestinationId, setSelectedDestinationId] = useState(null);
    const [selectedDestinationHandler, setSelectedDestinationHandler] = useState(null);
    const [formData, setFormData] = useState({ all_stations: [], origin_notify_status: 1, destination_notify_status: 1 });
    const [addressFor, setAddressFor] = useState('');
    const [handlerList, setHandlerList] = useState([]);
    const [inputAddress, setInputAddress] = useState({
        handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: ''
    });
    const [address, setAddress] = useState([]);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [stations, setStations] = useState([
        // { station: '', stationHandler: [], selectedDestinationHandler: null }
    ]);
    const [selectedButton, setSelectedButton] = useState('general');
    const [rfiles, setRfiles] = useState([]);
    const [sendData, setSendData] = useState({});
    // IMAGE UPLOAD START
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const [mailFiles, setMailFiles] = useState([]);
    const [editFiles, setEditFiles] = useState([]);
    const fileInputRef = useRef(null);
    const msgfileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);
    const [isEditable, setIsEditable] = useState(false);
    const [messageLists, setMessageLists] = useState([]);
    const [msgSec, setMsgSec] = useState({});
    // const [isLoading, setIsLoading] = useState(false);
    // IMAGE UPLOAD END
    // const [show, setShow] = useState(false);
    // // const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);

    const [addressModalShow, setAddressModalShow] = useState(false);
    const addressModalClose = () => { setAddressModalShow(false); setInputAddress({ handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: '' }) }

    const fetchStationData = async () => {
        try {

            const res = await withRFSToken.post(STATIONLIST, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchAddressData = async () => {
        try {

            const res = await withRFSToken.post(STATIONHANDLER, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.handler_org_id,
                        label: item.org_name,
                        email: item.handler_email_id
                    })) : [];
                    setHandlerList(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchOwnerCode = async () => {
        try {

            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA,
                        pref: item.AWB_prefix
                    })) : [];
                    setGetOwnerCode(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchRecoveryInformation = async (awbNumber) => {
        try {
            const res = await withRFSToken.post("service-recovery/recovery-information", { airway_bill: awbNumber });
            if (res.data.response_code === 200 && res.data.response_data != null) {
                const innerData = res.data.response_data;
                setFormData(innerData);
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const loadDetails = async (uldNumber) => {
        setIsLoading(true)
        try {
            const res = await withRFSToken.post(RECOVERYDETAILS, { service_recovery_id: uldNumber })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    setFormData(innerData);
                    setIsLoading(false)
                    setMsgSec({ 
                        service_recovery_id: innerData?.service_recovery_id, 
                        recovery_status: innerData?.recovery_status, 
                        created_by: innerData?.created_by 
                    })
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;

        // fetchDestination();
        fetchAddressData();
        fetchOwnerCode();
        fetchStationData();
        isMounted.current = true;
        const storedData = JSON.parse(localStorage.getItem('RecoveryEdit'));
        if (storedData) {
            // const transformData = {
            //     ...storedData,
            //     files: storedData.attachments
            // }
            if (storedData) { setSelectedButton(storedData.selb || 'general') }
            // fetchMessageList(storedData.service_recovery_id);
            // setFormData(storedData);
            // handleGetMail(storedData.master_airway_bill_prefix + '-' + storedData.master_airway_bill_no)
            setEditFiles(storedData.attachments)
            loadDetails(storedData.service_recovery_id);
        }
    }, []);

    const findPrimary = formData?.attachments?.filter((attachment) => attachment.primary === 1);
    const [highlightedFile, setHlightedFile] = useState("");
    const [imgShow, setImgShow] = useState(false);
    const handleImageClick = (file) => {
        setHlightedFile(file);
        setImgShow(true);
    };
    const handleClose = () => {
        setImgShow(false);
        setHlightedFile("");
    };

    useEffect(() => {
        // const storedData = JSON.parse(localStorage.getItem('RecoveryEdit'));
        if (formData?.origin) {
            const selectedDestination = getDestination.find(option => option.value === formData?.origin);
            if (selectedDestination) {
                setOriginHandler(selectedDestination.address);
                setSelectedOriginId(selectedDestination.station_id);
                if (formData?.origin_handler_id) {
                    const selectedOH = selectedDestination.address.find(option => option.id === formData?.origin_handler_id)
                    if (selectedOH) {
                        setSelectedOriginHandler({
                            value: selectedOH.id,
                            label: selectedOH.company_name,
                            email: selectedOH.handler_email_id,
                            address: selectedOH.address,
                            number: selectedOH.handler_phone_no,
                            id: selectedOH.id,
                            hoid: selectedOH.handler_org_id,
                        })
                    }
                }
            } else {
                setOriginHandler([]);
                setSelectedOriginId(null);
                setSelectedOriginHandler(null);
            }
        }
        if (formData?.destination) {
            const selectedDestination = getDestination.find(option => option.value === formData?.destination);

            if (selectedDestination) {
                setDestinationHandler(selectedDestination.address);
                setSelectedDestinationId(selectedDestination.station_id);
                if (formData.destination_handler_id) {
                    const selectedOH = selectedDestination.address.find(option => option.id === formData.destination_handler_id)
                    if (selectedOH) {
                        setSelectedDestinationHandler({
                            value: selectedOH.id,
                            label: selectedOH.company_name,
                            email: selectedOH.handler_email_id,
                            address: selectedOH.address,
                            number: selectedOH.handler_phone_no,
                            id: selectedOH.id,
                            hoid: selectedOH.handler_org_id,
                        })
                    }
                }
            } else {
                setDestinationHandler([]);
                setSelectedDestinationId(null);
                setSelectedDestinationHandler(null);
            }
        }
        // if (localStorage.getItem('RecoveryEdit')) {
        //     if (formData.all_stations && formData.all_stations.length > 0) {
        //         const initialStations = formData.all_stations.map(station => ({
        //             station: station.station_name || '',
        //             station_id: getDestination.find(dest => dest.value === station.station_name)?.station_id || '',
        //             stationHandler: station.handler_id ? getDestination.find(dest => dest.value === station.station_name)?.address || [] : [],
        //             selectedDestinationHandler: station.handler_id ? { value: station.handler_id, label: station.handler_name } : null,
        //             notifyChecked: station.notify_status === '1'
        //         }));
        //         setStations(initialStations);
        //     }
        // }
        if (localStorage.getItem('RecoveryEdit')) {
            if (formData?.all_stations && formData?.all_stations.length > 0) {
                const initialStations = formData?.all_stations.map(station => {
                    const matchingDestination = getDestination.find(dest => dest.value === station.station_name);

                    // `stationHandler` is populated based on `station.handler_id` and `station_name` matching in `getDestination`
                    const stationHandler = station.handler_id && matchingDestination ? matchingDestination.address || [] : [];

                    // `selectedDestinationHandler` uses `find` to locate the first matching handler by `handler_id`
                    const handlerData = stationHandler.find(handler => handler.id === station.handler_id);

                    const selectedDestinationHandler = handlerData ? {
                        value: handlerData.id,
                        label: handlerData.company_name,
                        email: handlerData.handler_email_id,
                        address: handlerData.address,
                        number: handlerData.handler_phone_no,
                        id: handlerData.id,
                        hoid: handlerData.handler_org_id,
                        station_id: handlerData.station_id
                    } : null;

                    return {
                        station: station.station_name || '',
                        station_id: matchingDestination?.station_id || '',
                        stationHandler,
                        selectedDestinationHandler, // Set transformed handler data as an object here
                        notifyChecked: station.notify_status === '1'
                    };
                });

                setStations(initialStations);
            }
        }

    }, [getDestination]);

    // ALL FORM
    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;

        let newValue = type === 'checkbox' ? checked : value;

        // if (name == 'origin_notify_status') {
        //     console.log('000', checked);

        //     setFormData(prevFormData => ({
        //         ...prevFormData,
        //         origin_notify_status: checked == true ? 1 : 0
        //     }));
        // } else if (name == 'destination_notify_status') {
        //     setFormData(prevFormData => ({
        //         ...prevFormData,
        //         destination_notify_status: checked == true ? 1 : 0
        //     }));
        // }

        if (name === 'master_airway_bill_prefix') {
            // const awbpref = getOwnerCodes?.find(prf => prf.AWB_prefix == value)
            if (value.length === 3) {
                const awbpref = getOwnerCodes?.find(prf => prf.pref === value);
                if (awbpref) {
                    // Update formData with the found flight_prefix
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        master_airway_bill_prefix: value,
                        flight_prefix: awbpref.value
                    }));
                    return; // Exit early to avoid re-setting formData again below
                }
            } else {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    master_airway_bill_prefix: value,
                    flight_prefix: ''
                }));
            }
        }
        if (name === 'master_airway_bill_no') {
            // Remove non-digits, and ensure it doesn't exceed 8 digits
            newValue = handleChange(value);
            const rawValue = newValue.replace(/\D/g, '');
            if (rawValue.length === 8 && formData.master_airway_bill_prefix?.length === 3) {
                const fullAWB = `${formData.master_airway_bill_prefix}-${rawValue}`;
                fetchRecoveryInformation(fullAWB);
            }

        }
        setFormData(prevFormData => {
            // const updatedAwbill1 = name === 'awbill1' ? newValue : prevFormData.awbill1 || '';
            // const updatedAwbill2 = name === 'awbill2' ? newValue : prevFormData.awbill2 || '';

            // return {
            //     ...prevFormData,
            //     [name]: newValue,
            //     master_airway_bill_no: `${updatedAwbill1}-${updatedAwbill2}`
            // };
            // When awbill1 or awbill2 is changed, update master_airway_bill_no
            // if (name === 'awbill1' || name === 'awbill2') {
            //     const newAirwayBill = `${formData.awbill1 || ''}-${formData.awbill2 || ''}`;

            //     return {
            //         ...prevFormData,
            //         [name]: newValue,
            //         master_airway_bill_no: newAirwayBill
            //     };
            // }
            if (name === 'recovery_aspects') {
                const updatedAspects = checked
                    ? [...(prevFormData.recovery_aspects || []), value] // Add the value if checked
                    : (prevFormData.recovery_aspects || []).filter(item => item !== value); // Remove the value if unchecked

                return {
                    ...prevFormData,
                    recovery_aspects: updatedAspects
                };
            }
            return { ...prevFormData, [name]: newValue };
        });
    };
    const handleChange = (value) => {
        // console.log(value);

        value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
        let formattedValue = '';

        // Add a space after the first 4 digits
        if (value.length > 4) {
            formattedValue += value.substr(0, 4) + ' ';
            value = value.substr(4);
        }

        formattedValue += value;
        return formattedValue.substr(0, 9); // Limit to 9 characters (8 digits + 1 space)
    };
    // ALL FORM

    // STATION SECTION
    const [selectedStation, setSelectedStation] = useState({});
    const handleAddStation = () => {
        setStations([
            ...stations,
            { station: '', station_id: '', stationHandler: [], selectedDestinationHandler: null, notifyChecked: false }
        ]);
        setFormData(prevFormData => ({
            ...prevFormData,
            all_stations: [
                ...prevFormData.all_stations,
                { station_name: '', handler_id: '', notify_status: '0' } // Default notify_status to "0"
            ]
        }));
    };
    const handleDeleteStation = (index) => {
        // Remove from stations array
        setStations(prevStations => prevStations.filter((_, idx) => idx !== index));

        // Remove from formData.all_stations
        setFormData(prevFormData => {
            const updatedStations = prevFormData.all_stations.filter((_, idx) => idx !== index);
            return { ...prevFormData, all_stations: updatedStations };
        });
    };

    const handleStationChange = (index, selected) => {
        const selectedDestination = getDestination.find(option => option.value === selected.value);
        setStations(prevStations =>
            prevStations.map((station, idx) =>
                idx === index
                    ? {
                        ...station,
                        station: selected.value,
                        station_id: selectedDestination.station_id,
                        stationHandler: selectedDestination ? selectedDestination.address : [],
                        selectedDestinationHandler: null
                    }
                    : station
            )
        );

        setFormData(prevFormData => {
            const updatedStations = [...prevFormData.all_stations];
            if (!updatedStations[index]) {
                updatedStations[index] = {};
            }
            // Ensure the object at the specific index exists, and set station_name
            updatedStations[index] = {
                ...updatedStations[index],       // Keep other existing properties
                station_name: selected.value,   // Set station_name explicitly
            };

            return { ...prevFormData, all_stations: updatedStations };
        });
    };

    const handleHandlerChange = (index, selected) => {
        setStations(prevStations =>
            prevStations.map((station, idx) =>
                idx === index
                    ? { ...station, selectedDestinationHandler: selected }
                    : station
            )
        );

        setFormData(prevFormData => {
            const updatedStations = [...prevFormData.all_stations];
            updatedStations[index] = {
                ...updatedStations[index],
                handler_id: selected.value
            };
            return { ...prevFormData, all_stations: updatedStations };
        });
    };
    const handleNotifyChange = (index, checked) => {
        setStations(prevStations =>
            prevStations.map((station, idx) =>
                idx === index
                    ? { ...station, notifyChecked: checked }
                    : station
            )
        );

        setFormData(prevFormData => {
            const updatedStations = [...prevFormData.all_stations];
            updatedStations[index] = {
                ...updatedStations[index],
                notify_status: checked ? '1' : '0'
            };
            return { ...prevFormData, all_stations: updatedStations };
        });
    };
    // STATION SECTION

    // ADDRESS MODAL
    const addressModalOpen = (addressType, slst) => {
        console.log("🚀 ~ addressModalOpen ~ slst:", slst)
        if (addressType == 'OH') {
            setInputAddress({
                handler_org_id: selectedOriginHandler.hoid,
                address: selectedOriginHandler.address,
                // handler_email_id: selectedOriginHandler.email,
                handler_email_id: Array.isArray(selectedOriginHandler.email) && selectedOriginHandler.email.length === 0 ? [''] : selectedOriginHandler.email,
                handler_phone_no: selectedOriginHandler.number,
                handler_contact_id: selectedOriginHandler?.id,
            });
        } else if (addressType == 'DH') {
            setInputAddress({
                handler_org_id: selectedDestinationHandler.hoid,
                address: selectedDestinationHandler.address,
                // handler_email_id: selectedDestinationHandler.email,
                handler_email_id: Array.isArray(selectedDestinationHandler.email) && selectedDestinationHandler.email.length === 0 ? [''] : selectedDestinationHandler.email,
                handler_phone_no: selectedDestinationHandler.number,
                handler_contact_id: selectedDestinationHandler?.id,
            });
        } else if (addressType == 'SH') {
            setInputAddress({
                handler_org_id: slst?.hoid,
                address: slst?.address,
                // handler_email_id: slst?.email,
                handler_email_id: Array.isArray(slst?.email) && slst?.email.length === 0 ? [''] : slst?.email,
                handler_phone_no: slst?.number,
                handler_contact_id: slst?.id,
            });
        }
        setSelectedStation(slst);
        setAddressFor(addressType);
        setAddressModalShow(true);
    }
    let orgLabel;
    if (selectedOriginId) {
        const idMatch = getDestination.find(option => option.station_id == selectedOriginId);
        orgLabel = idMatch.label;
    }
    let destLabel;
    if (selectedDestinationId) {
        const idMatch = getDestination.find(option => option.station_id == selectedDestinationId);
        destLabel = idMatch.label;
    }
    const handleAddressChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox' && name === 'regd') {
            setInputAddress({ ...inputAddress, [name]: checked ? '1' : '0' });
        } else {
            setInputAddress({ ...inputAddress, [name]: value });
        }
        console.log(inputAddress);
    };

    // Email array start
    const handleEmailChange = (index, value) => {
        setInputAddress((prev) => {
            const updatedEmails = [...prev.handler_email_id];
            updatedEmails[index] = value;
            return { ...prev, handler_email_id: updatedEmails };
        });
    };

    const addEmailField = () => {
        setInputAddress((prev) => ({
            ...prev,
            handler_email_id: [...prev.handler_email_id, '']
        }));
    };

    const removeEmailField = (index) => {
        setInputAddress((prev) => ({
            ...prev,
            handler_email_id: prev.handler_email_id.filter((_, i) => i !== index)
        }));
    };
    // Email array end

    const validateAddressData = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Function to validate email
        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!inputAddress.handler_org_id) {
            toast.error('Please select a Handler name');
            isValid = false;
        }
        // else if (!validateEmail(inputAddress.handler_email_id)) {
        //     toast.error('Please enter valid email address');
        //     isValid = false;
        // }
        else {
            return isValid;
        }
    };

    const addAddress = async (e) => {
        // console.log('444', inputAddress);
        if (validateAddressData()) {
            e.preventDefault();

            let stationid;
            if (addressFor == 'origin' || addressFor == 'OH') {
                stationid = selectedOriginId;
            } else if (addressFor == 'destination' || addressFor == 'DH') {
                stationid = selectedDestinationId;
            } else {
                stationid = selectedStation.station_id
            }
            const transformedEmails = inputAddress.handler_email_id.filter(email => email.trim() !== '');
            const NewInputAddress = { ...inputAddress, handler_email_id: transformedEmails, station_id: stationid };
            if (NewInputAddress) {
                try {
                    const res = await withRFSToken.post(SAVEHANDLER, NewInputAddress)
                        .then(function (res) {
                            // const innerData = res;
                            if (res.data.response_code == 200) {
                                toast.success(res.data.response_msg);
                                const newAddress = res.data.response_data;
                                setAddress(newAddress);
                                // fetchStationData();
                                fetchStationData();
                                if (addressFor === 'origin' || addressFor === 'destination') {

                                }
                                if (addressFor == 'origin') {
                                    setOriginHandler(prevHandlerNames => [
                                        ...prevHandlerNames,
                                        newAddress
                                    ]);
                                    // setTimeout(() => {
                                    //     if (originHandler.length === 1) {
                                    //         setSelectedOriginHandler({ value: newAddress.id, label: newAddress.company_name })
                                    //     }
                                    // }, 500);
                                } else if (addressFor == 'destination') {
                                    setDestinationHandler(prevHandlerNames => [
                                        ...prevHandlerNames,
                                        newAddress
                                    ]);
                                } else if (addressFor == 'OH') {
                                    const transformData = {
                                        value: newAddress?.id,
                                        label: newAddress?.company_name,
                                        email: newAddress?.handler_email_id,
                                        address: newAddress?.address,
                                        number: newAddress?.handler_phone_no,
                                        id: newAddress?.handler_contact_id,
                                        hoid: newAddress?.handler_org_id,
                                    }
                                    setSelectedOriginHandler(transformData);
                                } else if (addressFor == 'DH') {
                                    const transformData = {
                                        value: newAddress?.id,
                                        label: newAddress?.company_name,
                                        email: newAddress?.handler_email_id,
                                        address: newAddress?.address,
                                        number: newAddress?.handler_phone_no,
                                        id: newAddress?.handler_contact_id,
                                        hoid: newAddress?.handler_org_id,
                                    }
                                    setSelectedDestinationHandler(transformData);
                                } else if (addressFor == 'SH') {

                                    const transformData = {
                                        value: newAddress?.id,
                                        label: newAddress?.company_name,
                                        email: newAddress?.handler_email_id,
                                        address: newAddress?.address,
                                        number: newAddress?.handler_phone_no,
                                        id: newAddress?.handler_contact_id,
                                        hoid: newAddress?.handler_org_id,
                                        station_id: newAddress?.station_id
                                    }
                                    // console.log('transformData=1', transformData);
                                    // setSelectedStation(transformData);
                                    setStations(prevStations =>
                                        prevStations.map(station =>
                                            station.station_id === selectedStation.station_id
                                                ? {
                                                    ...station,
                                                    selectedDestinationHandler: transformData, // Update stationHandler with newAddress data
                                                    stationHandler: station.stationHandler.map(handler =>
                                                        handler.handler_org_id === newAddress.handler_org_id
                                                            ? { ...handler, ...newAddress } // Replace the matched handler with newAddress
                                                            : handler // Keep the other handlers unchanged
                                                    ),
                                                }
                                                : station
                                        )
                                    );
                                } else {
                                    // const stnHandler = stations?.find(name => name.station === selectedStation.station);

                                    setStations(prevStations =>
                                        prevStations.map(station =>
                                            station.station === selectedStation.station
                                                ? {
                                                    ...station,
                                                    stationHandler: [...station.stationHandler, newAddress] // Update stationHandler with newAddress data
                                                }
                                                : station
                                        )
                                    );
                                }
                                setInputAddress({
                                    handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: ''
                                });
                                // console.log(address);
                                addressModalClose();
                            } else {
                                toast.error(res.data.response_msg);
                            }
                        });

                } catch (error) {
                    console.error('Error sending request:', error);
                }
            }
        }
    }
    // ADDRESS MODAL END

    // IMAGE UPLOAD START
    const [isTopDel, setIsTopDel] = useState(false);


    // const handleBrowseFiles = (e) => {
    //     e.preventDefault();
    //     fileInputRef.current.click();
    // };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    //     const selectedFiles = Array.from(e.target.files);
    //     const filesWithBase64 = [];
    //     let filesProcessed = 0;

    //     // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
    //     const existingBase64Files = formData?.base64Files || [];
    //     const existingFiles = formData?.files || [];

    //     selectedFiles.forEach((file) => {
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
    //             filesProcessed += 1;
    //             if (filesProcessed === selectedFiles.length) {
    //                 const newFiles = filesWithBase64.map((obj) => obj.file);
    //                 // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
    //                 const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
    //                 const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
    //                 const mergedFiles = [...existingFiles, ...newBase64Files];
    //                 // setFiles(newFiles);
    //                 setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    //                 setBase64Files(mergedBase64Files);
    //                 setFormData((prevFormData) => {
    //                     // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
    //                     const newFormData = { ...prevFormData, files: mergedFiles, base64Files: mergedBase64Files };

    //                     return newFormData;
    //                 });
    //             }
    //         };
    //         reader.readAsDataURL(file);
    //     });
    // };

    // IMAGE UPLOAD END

    const [activeStep, setActiveStep] = useState(0);
    const [finishStep, setFinishStep] = useState(false);
    const [uploadTarget, setUploadTarget] = useState('');
    const fileInputRefs = useRef({});
    const [checkList, setCheckList] = useState({});
    const [confModal, setConfModal] = useState(false);
    const [modalSection, setModalSection] = useState('');
    const [modalData, setModalData] = useState({});
    const [typeData, setTypeData] = useState('');

    const steps = [
        { label: (<>Recovery Information</>), icon: <img src={firstImage} /> },
        { label: (<>Incident Information</>), icon: <img src={secondImage} /> },
        { label: (<>Upload Attachment</>), icon: <img src={secondImage} /> },
    ];

    const stepNext = () => {
        if (activeStep === 0) {
            if (!formData.master_airway_bill_prefix) {
                toast.error("Please Add Master Airway Bill Prefix");
                return;
            }
            if (!formData.master_airway_bill_no) {
                toast.error("Please Add Master Airway Bill Number");
                return;
            }
            if (!formData.flight_prefix) {
                toast.error("Please Add Flight Prefix");
                return;
            }
            if (!formData.flight_no) {
                toast.error("Please Add Flight Number");
                return;
            }
            if (!formData.flight_date) {
                toast.error("Please Select Flight Date");
                return;
            }
            if (!formData?.origin) {
                toast.error("Please Select Origin");
                return;
            }
            if (!formData.origin_handler_id) {
                toast.error("Please Select Origin Handler");
                return;
            }
            if (!formData?.destination) {
                toast.error("Please Select Destination");
                return;
            }
            if (!formData.destination_handler_id) {
                toast.error("Please Select Destination Handler");
                return;
            }
        } else if (activeStep === 1) {
            if (!formData.total_mawb_pieces) {
                toast.error("Please enter Total Mawb Pieces");
                return;
            }
            if (!formData.total_mawb_wght) {
                toast.error("Please enter Total Mawb Weight");
                return;
            }
            if (!formData.pieces_involved) {
                toast.error("Please enter Pieces Involved");
                return;
            }
            if (!formData.pieces_wght) {
                toast.error("Please enter Involved Weight");
                return;
            }
            if (!formData.recovery_aspects || !formData.recovery_aspects?.length > 0) {
                toast.error("Please Select Recovery Aspects");
                return;
            }
        }

        // Move to the next step if all validations passed
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        // if (boolNext == 1) {
        //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
        // }
    };
    const stepBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    console.log('formData', formData);

    const handleFinish = async () => {
        setIsLoading(true);
        // let transformedData;
        // if (localStorage.getItem('RecoveryEdit')) {

        // } else {
        const filterPrimary = editFiles?.filter(file => file.primary === 1);
        const restFiles = editFiles?.filter((file) => !file.primary || file.primary !== 1);
        const getOrigin = formData.stations.find(i => i.handler_type == 'Origin');
        const getDest = formData.stations.find(i => i.handler_type == 'Destination');
        const transformedData = {
            ...formData,
            origin_notify_status: formData.origin_notify_status == true ? 1 : 0,
            destination_notify_status: formData.origin_notify_status == true ? 1 : 0,
            all_stations: [
                {
                    handler_feedback_id: getOrigin.handler_feedback_id,
                    station_name: formData.origin,
                    handler_id: formData.origin_handler_id,
                    notify_status: formData.origin_notify_status == true ? 1 : 0
                },
                {
                    handler_feedback_id: getDest.handler_feedback_id,
                    station_name: formData?.destination,
                    handler_id: formData.destination_handler_id,
                    notify_status: formData.destination_notify_status == true ? 1 : 0
                },
                ...formData?.all_stations
            ],
            files: [
                ...(formData.files || []),
                ...filterPrimary.map((file) => ({ id: file.id, primary: file.primary })),
                ...restFiles.map((file) => ({ id: file.id, primary: 0 })),
            ]
        };
        // }
        // console.log("🚀 ~ handleFinish ~ transformedData:", transformedData)

        try {
            const res = await withRFSToken.post(SAVERECOVERY, transformedData)
                .then(function (res) {
                    setIsLoading(false);
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);
                        // setTimeout(() => {
                        window.location.href = '/ServiceRecovery';
                        // }, 1000);
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleStepClick = async () => {
    }

    // image select
    const [selectedKeys, setSelectedKeys] = useState([]);

    const handleImageSelect = (key, data) => {
        console.log("🚀 ~ handleImageSelect ~ data:", data)

        // if (formData.files) {
        const extension = data?.file_name?.split('.').pop().toLowerCase();
        console.log("🚀 ~ handleImageSelect ~ extension:", extension)
        if (["jpeg", "jpg", "png", "webp"].includes(extension)) {
            // setFormData((prevFormData) => {
            //     const updatedFiles = prevFormData.files.map((file, index) => {
            //         if (index === key) {
            //             // Toggle the "primary" field for the selected file
            //             return {
            //                 ...file,
            //                 primary: file.primary === 1 ? 0 : 1,
            //             };
            //         }
            //         return file;
            //     });

            //     return {
            //         ...prevFormData,
            //         files: updatedFiles,
            //     };
            // });
            setFiles((prevFiles) =>
                prevFiles.map((file, index) =>
                    index === key
                        ? { ...file, primary: file.primary === 1 ? 0 : 1 } // Toggle primary between 1 and 0
                        : file // Leave other files unchanged
                )
            );
            setSelectedKeys((prevSelected) =>
                prevSelected.includes(key)
                    ? prevSelected.filter((selectedKey) => selectedKey !== key)
                    : [...prevSelected, key]
            );
            // }
        }
        // if (["jpeg", "jpg", "png", "webp"].includes(data?.file_type)) {

        //     setEditFiles((prevFiles) =>
        //         prevFiles.map((file) =>
        //             file.id === data.id
        //                 ? { ...file, primary: file.primary === 1 ? 0 : 1 } // Toggle primary between 1 and 0
        //                 : file // Leave other files unchanged
        //         )
        //     );
        // }

    };

    // ===============================================code  24.06.2025=================================================
    const [activeTab, setActiveTab] = useState('All');

    const handleButtonClick = async (button) => {
        if (button == 'remarks') { setActiveStep(2) }
        else if (button == 'attachment') {
            setActiveStep(1);
            if (!formData.id && formData.master_airwaybill) {
                try {
                    const res = await withRFSToken.post('shipment/save-import-shipment-record', formData);
                    // console.log('API Response:', res.data);
                    if (res.data.response_code === 200) {
                        localStorage.setItem('SHEdit', JSON.stringify(res.data.response_data.id));
                        setFormData(res.data.response_data);
                    }
                } catch (error) {
                    console.error('Error saving shipment record:', error);
                }
            }
        }
        else { setActiveStep(0) }
        setSelectedButton(button);
    };

    const toggleAccordionItem = async (index, msg, pos) => {

        setExpandedKeys(prevKeys =>
            prevKeys.includes(index.toString())
                ? prevKeys.filter(key => key !== index.toString()) // Remove key to collapse
                : [...prevKeys, index.toString()] // Add key to expand
        );
    };

    function extractPath(url) {
        try {
            let urlObject = new URL(url);
            let path = urlObject.pathname.substring(1);
            return path;
        } catch (error) {
            console.error("Invalid URL:", error);
            return null;
        }
    }
    const handleDownload = async (imageUrl, imageName) => {
        const path = extractPath(imageUrl);
        const res = await withRFSToken
            .post("get-file-blob", {
                file_path: path,
            })
            .then((response) => {
                const pdfData = atob(response.data.response_data.file_base64);
                const byteNumbers = new Array(pdfData.length);
                for (let i = 0; i < pdfData.length; i++) {
                    byteNumbers[i] = pdfData.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                    type: response.data.response_data.mime_type,
                });
                saveAs(blob, imageName);
            })
            .catch((error) => {
                console.error("Error during the file download:", error);
                alert("Could not download the file");
            });
    };

    const conversationChange = (event) => {
        const { name, value, } = event.target;
        setSendData(prevFormData => {
            const newFormData = { ...prevFormData, [name]: value };

            return newFormData;
        });
    }

    const handleTabChange = async (tab) => {
        setActiveTab(tab);
    }

    // IMAGE UPLOAD START
    const imageModalUpload = () => {
        setShowModalUpload(true);
    }
    const closeModalUpload = () => {
        setShowModalUpload(false);
        setFiles([])
        setBase64Files([])
    }
    const handleDrop = (e) => {
        e.preventDefault();
        console.log('E', e);

        const droppedFiles = Array.from(e.dataTransfer.files);
        const selectedFiles = Array.from(e.dataTransfer.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = async () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    let newBase64Files;
                    if (uploadTarget) {
                        newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [uploadTarget] }));
                    } else {
                        newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    }
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];

                    // setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files(mergedBase64Files);
                    setSendData((prevFormData) => {
                        // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        const newFormData = { ...prevFormData, attachments: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
        // setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        // getBase64(droppedFiles[0]);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index, pos) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        setMailFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        if (pos == 'R') {
            setRfiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
        }
        // base64Files.splice(index, 1);
        setBase64Files((prevBase64Files) => {
            const newBase64Files = [...prevBase64Files];
            newBase64Files.splice(index, 1);
            if (pos == 'R') {

                setSendData((prevFormData) => {
                    // const newFiles = [...prevFormData.files];
                    const newFiles = Array.isArray(prevFormData.files) ? [...prevFormData.files] : [];
                    newFiles.splice(index, 1);
                    return { ...prevFormData, files: newFiles };
                });
            }
            // Update local storage


            return newBase64Files;
        });
    };

    const handleBrowseFiles = (e, nam) => {
        e.preventDefault();
        console.log('fileInputRef.current', fileInputRef);
        if (nam) {
            if (fileInputRefs.current[nam]) {
                fileInputRefs.current[nam].click();
            }
        } else { fileInputRef.current.click(); }
    };


    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleChecklicstChange = (e) => {
        const { value, checked } = e.target;
        setCheckList(prevFormData => {
            let updatedSpecifications = [...(prevFormData.check_list || [])];
            if (checked) {
                updatedSpecifications.push(value); // Add selected option
            } else {
                updatedSpecifications = updatedSpecifications.filter(spec => spec !== value); // Remove unselected option
            }
            return {
                ...prevFormData,
                check_list: updatedSpecifications,
            };
        });
    }
    const handleFileChange = (e, pos, chk) => {

        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = async () => {
                if (file.size > 26214400) {
                    toast.error(`${file.name} is too large. Maximum file size is 25MB.`);
                    return;
                }
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name, type: file.type });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    // if (pos === 'C') { // pos === 'A' || 
                    //     // const newFiles = filesWithBase64.map((obj) => obj.file);
                    //     // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    //     const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [chk] }));
                    //     const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    //     // setFiles(newFiles);


                    //     const payload = {
                    //         shipmen_id: formData.id,
                    //         shipmen_type: "export",
                    //         attachments: mergedBase64Files
                    //     }
                    //     // console.log('payload', payload);
                    //     try {
                    //         const res = await withRFSToken.post('shipment/upload-doc', payload);
                    //         console.log('API Response:', res.data);
                    //         if (res.data.response_code === 200) {
                    //             toast.success(res.data.response_msg);
                    //             setFormData(res.data.response_data);
                    //         } else {
                    //             toast.error(res.data.response_msg);
                    //         }
                    //     } catch (error) {
                    //         console.error('Error saving shipment record:', error);
                    //     }

                    // } else {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    console.log("🚀 ~ reader.onloadend= ~ newFiles:", filesWithBase64);
                    let newBase64Files;
                    if (pos === 'C') {
                        newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [chk] }));
                    } else {
                        newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    }
                    console.log('newBase64Files', newBase64Files);

                    // const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];

                    // setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files(mergedBase64Files);
                    if (pos == 'R') {
                        setRfiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, type: obj.type }))]);
                        setSendData((prevFormData) => {
                            // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                            const newFormData = { ...prevFormData, attachments: mergedBase64Files };

                            return newFormData;
                        });
                    }
                    if (pos == 'M') {
                        // const newFiles = filesWithBase64.map((obj) => obj.file);
                        // setMailFiles((prevFiles) => [...prevFiles, ...newFiles]);
                        // setMailForm((prevFormData) => {
                        //     // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        //     const newFormData = { ...prevFormData, attachments: mergedBase64Files };

                        //     return newFormData;
                        // });
                    }

                    // }
                }
            };
            reader.readAsDataURL(file);
        });


    };
    const imageUpload = async () => {
        // setGridSelect(prevGridSelect =>
        //     prevGridSelect.map(item => {
        //         if (item.uid === selectedRowId) {
        //             return { ...item, files: files, base64Files: base64Files };
        //         }
        //         return item;
        //     })
        // );
        // setShowModalUpload(false);
        const payload = {
            attachable_id: formData.service_recovery_id,
            attachable_type: "service_recovery",
            files: files
        }
        // console.log('payload', payload);
        try {
            const res = await withRFSToken.post('attachment-save', payload);
            console.log('API Response:', res.data);
            if (res.data.response_code === 200) {
                toast.success(res.data.response_msg);
                loadDetails(formData.service_recovery_id);
                setShowModalUpload(false);
                setFiles([])
                setBase64Files([]);
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error saving shipment record:', error);
        }
    };
    // IMAGE UPLOAD END

    const handleOpenModal = (pos, data) => {
        setModalData(data);
        setConfModal(true);
        setModalSection(pos);
        // setTypeData(data.category[0])
    }

    const closeConfirm = () => {
        setModalData();
        setConfModal(false);
        setModalSection();
        // setTypeData(data.category[0])
    }

    const handleConfirmation = async () => {

    }

    const handleToggleEdit = () => {
        if (isEditable) {
            handleFinish();
            setIsEditable(false)

        } else {
            setIsEditable(true)
        }
    }

    const updateRecovery = () => {
        localStorage.removeItem('RecoveryUpdate');
        localStorage.removeItem('BackRecoveryUpdate');
        localStorage.setItem('RecoveryUpdate', JSON.stringify(formData.service_recovery_id));
        localStorage.setItem('BackRecoveryUpdate', '/AddRecovery');
        const fnPageUrl = '/UpdateRecoveryCase';
        window.location.href = fnPageUrl;
    }

    const [closeRecModal, setCloseRecModal] = useState(false);
    const [recStat, setRecStat] = useState('');

    const openClRec = (stat) => {
        setCloseRecModal(true);
        setRecStat(stat);
    }
    const closeRecModalClose = () => {
        setCloseRecModal(false)
    }
    const confirmCloseRecovery = async () => {
        const c_type = formData?.recovery_status == 'Closed' ? 'o' : 'c';
        try {
            const res = await withRFSToken.post(SROPENCLOSE, { service_recovery_id: formData?.service_recovery_id, action: c_type })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);
                        // if (isSwitchOn == true) { setIsSwitchOn(false) } else { setIsSwitchOn(true) }
                        loadDetails(formData.service_recovery_id);
                        closeRecModalClose();
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    return (
        <>
            <div className="">
                {isLoading &&
                    <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                }
                <Header page_type='srecovery' logo_url='/ServiceRecovery' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        {/* <Link to='/ServiceRecovery' className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link> */}
                        <div className='d-flex justify-content-between mb-3'>
                            <div>
                                <button className={selectedButton === 'back' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => window.location.replace('/ServiceRecovery')}>
                                    <FontAwesomeIcon icon={faArrowLeft} /> <span>Back</span><span>{formData?.master_airway_bill_prefix + ' - ' + formData?.master_airway_bill_no}</span>
                                </button>
                                <button className={selectedButton === 'general' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('general')}>
                                    <img src={selectedButton === 'general' ? AssetsIconw : AssetsIcon} /> <span>Details</span>
                                </button>
                                <button className={selectedButton === 'messages' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('messages')}>
                                    <img src={selectedButton === 'messages' ? AssetsIconw : AssetsIcon} /> <span>Messages</span>
                                </button>
                                <button className={selectedButton === 'attachment' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('attachment')}>
                                    <img src={selectedButton === 'attachment' ? AssetsIconw : AssetsIcon} /> <span>Attachments</span>
                                </button>
                                {/* <button className={selectedButton === 'history' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('history')}>
                                    <img src={selectedButton === 'history' ? AssetsIconw : AssetsIcon} /> <span>History</span>
                                </button>
                                <button className={selectedButton === 'tmanage' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('tmanage')}>
                                    <img src={selectedButton === 'tmanage' ? AssetsIconw : AssetsIcon} /> <span>Task Management</span>
                                </button>
                                <button className={selectedButton === 'dmanage' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('dmanage')}>
                                    <img src={selectedButton === 'dmanage' ? AssetsIconw : AssetsIcon} /> <span>Doc Management</span>
                                </button>
                                <button className={selectedButton === 'invoice' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('invoice')}>
                                    <img src={selectedButton === 'invoice' ? AssetsIconw : AssetsIcon} /> <span>Invoice</span>
                                </button> */}
                            </div>
                            <div>

                                {formData?.recovery_status == 'Closed' ?
                                    <button className='close_recovery' onClick={() => openClRec('c')}>
                                        <FontAwesomeIcon icon={faXmark} /><span> Re-open Recovery</span>
                                    </button>
                                    :
                                    <button className='close_recovery' onClick={() => openClRec('o')}>
                                        <FontAwesomeIcon icon={faXmark} /><span> Close Recovery</span>
                                    </button>
                                }

                            </div>
                        </div>
                        <div className='new_recovery' >
                            {/* {isLoading ? <><div className='mvt loader-container h-100'><span className='mvt loader' style={{ left: '48%', top: '48%' }}></span></div></> : ''} */}

                            <Row className='mt-3'>
                                <Col sm='9'>
                                    {selectedButton === 'general' &&
                                        <Row className='h-100'>
                                            <Col lg={6} className='mb-3'>
                                                <div className='flbg details h-100'>
                                                    <div className='ship_head'>
                                                        <h4 className='d-flex w-100 justify-content-between'>Recovery Information <button onClick={handleToggleEdit} className='serv_edit_save ms-2' ><FontAwesomeIcon icon={faPencilAlt} className='pe-1' /> {isEditable ? "SAVE" : "EDIT"}</button></h4>
                                                    </div>
                                                    <Form className='recover_middle'>
                                                        {/* MAWB */}
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Master Airway Bill <span>*</span></Form.Label>
                                                            <Row>
                                                                <Col sm="3" className='pe-0'>
                                                                    <Form.Control
                                                                        type="number"
                                                                        name='master_airway_bill_prefix'
                                                                        maxLength='3'
                                                                        onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 3); }}
                                                                        onChange={handleInputChange}
                                                                        value={formData?.master_airway_bill_prefix || ''}
                                                                        disabled={!isEditable}
                                                                    />
                                                                </Col>
                                                                <Col className='add_hifen'>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name='master_airway_bill_no'
                                                                        maxLength={9}
                                                                        onChange={handleInputChange}
                                                                        value={formData?.master_airway_bill_no || ''}
                                                                        disabled={!isEditable}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Form.Group>

                                                        {/* Flight Prefix and Number */}
                                                        <Form.Group as={Row} className="mb-2">
                                                            <Col sm="3" className='pe-0'>
                                                                <Form.Label>Flight <span>*</span></Form.Label>
                                                                <Select
                                                                    options={getOwnerCodes}
                                                                    onChange={(selected) => {
                                                                        setFormData(prev => ({ ...prev, flight_prefix: selected.value }));
                                                                    }}
                                                                    placeholder="Flight"
                                                                    className='autoslct w-100'
                                                                    name="flight_prefix"
                                                                    value={getOwnerCodes.find(option => option.value === formData?.flight_prefix) || ''}
                                                                    isDisabled={!isEditable}
                                                                />
                                                            </Col>
                                                            <Col className='add_hifent'>
                                                                <Form.Label>Number <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name='flight_no'
                                                                    maxLength='8'
                                                                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                    value={formData?.flight_no || ''}
                                                                    onChange={handleInputChange}
                                                                    disabled={!isEditable}
                                                                />
                                                            </Col>
                                                        </Form.Group>

                                                        {/* Flight Date */}
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Flight Date <span>*</span></Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                name="flight_date"
                                                                value={formData?.flight_date || ''}
                                                                onChange={handleInputChange}
                                                                disabled={!isEditable}
                                                            />
                                                        </Form.Group>

                                                        {/* Origin & Handler */}
                                                        <Form.Group as={Row} className="mb-2">
                                                            <Col sm="4" className='pe-0'>
                                                                <Form.Label>Origin <span>*</span></Form.Label>
                                                                <Select
                                                                    options={getDestination}
                                                                    onChange={(selected) => {
                                                                        const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                                        setOriginHandler(selectedDestination ? selectedDestination.address : []);
                                                                        setSelectedOriginId(selectedDestination.station_id);
                                                                        setSelectedOriginHandler(null);
                                                                        setFormData(prev => ({ ...prev, origin: selected.value }));
                                                                    }}
                                                                    placeholder="Origin"
                                                                    className='autoslct w-100'
                                                                    name="origin"
                                                                    value={getDestination.find(option => option.value === formData?.origin) || ''}
                                                                    isDisabled={!isEditable}
                                                                />
                                                            </Col>
                                                            <Col sm="7" className='pe-0 position-relative'>
                                                                <label className="form-label">
                                                                    Origin Handler Name <span>*</span>
                                                                    {formData?.origin && isEditable && (
                                                                        <Link to='#' onClick={() => addressModalOpen('origin')} className='raad_adrss'>+ Add</Link>
                                                                    )}
                                                                </label>
                                                                <Select
                                                                    options={originHandler.map(handler => ({
                                                                        value: handler?.id,
                                                                        label: handler?.company_name,
                                                                        email: handler?.handler_email_id,
                                                                        address: handler?.address,
                                                                        number: handler?.handler_phone_no,
                                                                        id: handler?.id,
                                                                        hoid: handler?.handler_org_id,
                                                                    }))}
                                                                    onChange={(selected) => {
                                                                        setSelectedOriginHandler(selected);
                                                                        setFormData(prev => ({ ...prev, origin_handler_id: selected.value }));
                                                                    }}
                                                                    placeholder="Handler Name"
                                                                    className='autoslct w-100'
                                                                    name="origin_handler_id"
                                                                    value={selectedOriginHandler ? { value: selectedOriginHandler.value, label: selectedOriginHandler.label } : ''}
                                                                    isDisabled={!originHandler.length || !isEditable}
                                                                />
                                                            </Col>
                                                            <Col sm="1" className='align-self-center mt-20'>
                                                                {selectedOriginHandler &&
                                                                    (selectedOriginHandler?.email.some(e => e.trim() !== "")
                                                                        ? <Link to='#' onClick={() => addressModalOpen('OH')}><img src={MailGreen} /></Link>
                                                                        : <Link to='#' onClick={() => addressModalOpen('OH')}><img src={MailRed} /></Link>
                                                                    )
                                                                }
                                                            </Col>
                                                        </Form.Group>

                                                        {/* Destination & Handler */}
                                                        <Form.Group as={Row} className="mb-2">
                                                            <Col sm="4" className='pe-0'>
                                                                <Form.Label>Destination <span>*</span></Form.Label>
                                                                <Select
                                                                    options={getDestination}
                                                                    onChange={(selected) => {
                                                                        const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                                        setDestinationHandler(selectedDestination ? selectedDestination.address : []);
                                                                        setSelectedDestinationId(selectedDestination.station_id);
                                                                        setSelectedDestinationHandler(null);
                                                                        setFormData(prev => ({ ...prev, destination: selected.value }));
                                                                    }}
                                                                    placeholder="Origin"
                                                                    className='autoslct w-100'
                                                                    name="origin"
                                                                    value={getDestination.find(option => option.value === formData?.destination) || ''}
                                                                    isDisabled={!isEditable}
                                                                />
                                                            </Col>
                                                            <Col sm="7" className='pe-0 position-relative'>
                                                                <label className="form-label">
                                                                    Origin Handler Name <span>*</span>
                                                                    {formData?.destination && isEditable && (
                                                                        <Link to='#' onClick={() => addressModalOpen('destination')} className='raad_adrss'>+ Add</Link>
                                                                    )}
                                                                </label>
                                                                <Select
                                                                    options={destinationHandler.map(handler => ({
                                                                        value: handler?.id,
                                                                        label: handler?.company_name,
                                                                        email: handler?.handler_email_id,
                                                                        address: handler?.address,
                                                                        number: handler?.handler_phone_no,
                                                                        id: handler?.id,
                                                                        hoid: handler?.handler_org_id,
                                                                    }))}
                                                                    onChange={(selected) => {
                                                                        setSelectedDestinationHandler(selected);
                                                                        setFormData(prev => ({ ...prev, destination_handler_id: selected.value }));
                                                                    }}
                                                                    placeholder="Handler Name"
                                                                    className='autoslct w-100'
                                                                    name="origin_handler_id"
                                                                    value={selectedDestinationHandler ? { value: selectedDestinationHandler.value, label: selectedDestinationHandler.label } : ''}
                                                                    isDisabled={!destinationHandler.length || !isEditable}
                                                                />
                                                            </Col>
                                                            <Col sm="1" className='align-self-center mt-20'>
                                                                {selectedDestinationHandler &&
                                                                    (selectedDestinationHandler?.email.some(e => e.trim() !== "")
                                                                        ? <Link to='#' onClick={() => addressModalOpen('DH')}><img src={MailGreen} /></Link>
                                                                        : <Link to='#' onClick={() => addressModalOpen('DH')}><img src={MailRed} /></Link>
                                                                    )
                                                                }
                                                            </Col>
                                                        </Form.Group>
                                                        {/* repeat same structure with isDisabled={!isEditable} */}

                                                        {/* Station Loop */}
                                                        {stations.map((station, index) => (
                                                            <div key={index}>
                                                                <Form.Group as={Row} className="my-3 add_station position-relative">
                                                                    <Col sm="4" className='pe-0'>
                                                                        <Form.Label>Station <span>*</span></Form.Label>
                                                                        <Select
                                                                            options={getDestination}
                                                                            onChange={(selected) => handleStationChange(index, selected)}
                                                                            placeholder="Destination"
                                                                            className='autoslct w-100'
                                                                            name={`station-${index}`}
                                                                            value={getDestination.find(option => option.value === station.station) || ''}
                                                                            isDisabled={!isEditable}
                                                                        />
                                                                    </Col>
                                                                    <Col sm="7" className='pe-0 position-relative'>
                                                                        <label className="form-label">
                                                                            Station Handler Name <span>*</span>
                                                                            {station.station && isEditable && (
                                                                                <Link to='#' onClick={() => addressModalOpen('station', station)} className='raad_adrss'>+ Add</Link>
                                                                            )}
                                                                        </label>
                                                                        <Select
                                                                            options={station.stationHandler.map(handler => ({
                                                                                value: handler.id,
                                                                                label: handler.company_name,
                                                                                email: handler.handler_email_id,
                                                                                address: handler.address,
                                                                                number: handler.handler_phone_no,
                                                                                id: handler.id,
                                                                                hoid: handler.handler_org_id,
                                                                                station_id: handler.station_id
                                                                            }))}
                                                                            onChange={(selected) => handleHandlerChange(index, selected)}
                                                                            placeholder="Handler Name"
                                                                            className='autoslct w-100'
                                                                            name={`station_handler-${index}`}
                                                                            value={station.selectedDestinationHandler ? { value: station.selectedDestinationHandler.value, label: station.selectedDestinationHandler.label } : ''}
                                                                            isDisabled={!station.stationHandler.length || !isEditable}
                                                                        />
                                                                    </Col>
                                                                    <Col sm="1" className='align-self-center mt-20'>
                                                                        {station.selectedDestinationHandler &&
                                                                            (station.selectedDestinationHandler?.email.some(e => e.trim() !== "")
                                                                                ? <Link to='#' onClick={() => addressModalOpen('SH', station.selectedDestinationHandler)}><img src={MailGreen} /></Link>
                                                                                : <Link to='#' onClick={() => addressModalOpen('SH', station.selectedDestinationHandler)}><img src={MailRed} /></Link>
                                                                            )
                                                                        }
                                                                    </Col>

                                                                    <Link to="#" onClick={() => handleDeleteStation(index)} className='recovery_trash' style={{ pointerEvents: isEditable ? 'auto' : 'none', opacity: isEditable ? 1 : 0.5 }}>
                                                                        <img src={Trash} />
                                                                    </Link>
                                                                </Form.Group>
                                                            </div>
                                                        ))}

                                                        <Button variant="outline-primary" className='more_btn mt-3' onClick={handleAddStation} disabled={!isEditable}>
                                                            Add More Station's
                                                        </Button>
                                                    </Form>
                                                </div>
                                            </Col>

                                            {/* Incident Info */}
                                            <Col lg={6} className='mb-3'>
                                                <div className='flbg details mb-3 h-100'>
                                                    <div className='ship_head'>
                                                        <h4>Incident Information</h4>
                                                    </div>
                                                    <Form className='recover_middle'>
                                                        <Form.Group as={Row} className="mb-2">
                                                            <Col>
                                                                <Form.Label>Total MAWB Pieces <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    name='total_mawb_pieces'
                                                                    value={formData?.total_mawb_pieces || ''}
                                                                    onChange={handleInputChange}
                                                                    disabled={!isEditable}
                                                                />
                                                            </Col>
                                                            <Col>
                                                                <Form.Label>Weight (Kg) <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    name='total_mawb_wght'
                                                                    value={formData?.total_mawb_wght || ''}
                                                                    onChange={handleInputChange}
                                                                    disabled={!isEditable}
                                                                />
                                                            </Col>
                                                        </Form.Group>

                                                        <Form.Group as={Row} className="mb-2">
                                                            <Col>
                                                                <Form.Label>Pieces involved <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    name='pieces_involved'
                                                                    value={formData?.pieces_involved || ''}
                                                                    onChange={handleInputChange}
                                                                    disabled={!isEditable}
                                                                />
                                                            </Col>
                                                            <Col>
                                                                <Form.Label>Involved Weight (Kg) <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    name='pieces_wght'
                                                                    value={formData?.pieces_wght || ''}
                                                                    onChange={handleInputChange}
                                                                    disabled={!isEditable}
                                                                />
                                                            </Col>
                                                        </Form.Group>

                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Recovery Aspects <span>*</span></Form.Label>
                                                            {['MSCA', 'FDCA', 'DMA'].map(option => (
                                                                <Form.Check
                                                                    key={option}
                                                                    inline
                                                                    type="checkbox"
                                                                    label={option}
                                                                    value={option}
                                                                    name='recovery_aspects'
                                                                    onChange={handleInputChange}
                                                                    checked={formData?.recovery_aspects?.includes(option)}
                                                                    disabled={!isEditable}
                                                                />
                                                            ))}
                                                        </Form.Group>

                                                        <Form.Group>
                                                            <Form.Label>Comment</Form.Label>
                                                            <Form.Control as="textarea" name='comment' rows={5} onChange={handleInputChange} value={formData?.comment} disabled={!isEditable} />
                                                        </Form.Group>
                                                    </Form>
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                    {selectedButton === 'messages' &&
                                        <Message data={msgSec} />
                                    }
                                    {selectedButton === 'attachment' &&
                                        <Attachment propdata={formData} />
                                    }
                                    {/* {selectedButton === 'history' &&
                                        <></>
                                    } */}
                                    {selectedButton === 'remarks' &&
                                        <>
                                            <div className='chat_bg'>
                                                <div className='flbg right_side record_remarks'>
                                                    <div className='chat_box'>
                                                        {formData?.remarks?.map((msg, index) => (
                                                            <>
                                                                <Accordion key={index} activeKey={expandedKeys}>
                                                                    <Accordion.Item eventKey={index.toString()}>
                                                                        <Accordion.Header onClick={() => toggleAccordionItem(index, msg, 'all')} className=''>
                                                                            <div className='position-relative'><img src={Pack} /> {msg.created_by}</div>
                                                                            <div className='acorright'> {msg.attachments?.length > 0 && <FontAwesomeIcon icon={faPaperclip} />} <span>{msg.date} | {msg.time}</span></div></Accordion.Header>
                                                                        <Accordion.Body>
                                                                            {msg.message}
                                                                            {msg.attachments?.length > 0 &&
                                                                                <div className='d-flex mt-1 '>
                                                                                    {msg.attachments?.map((file, index) => {
                                                                                        const fileName = file?.file_name;
                                                                                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                                        const extension = fileName?.split(".").pop();
                                                                                        return (
                                                                                            <>
                                                                                                <div key={`ns_${index}`} className="mag_image">
                                                                                                    {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                                                                    ) ? (
                                                                                                        <>
                                                                                                            <img
                                                                                                                src={file.file_path}
                                                                                                                alt="Preview"
                                                                                                                className=''
                                                                                                                style={{
                                                                                                                    maxWidth: "30px",
                                                                                                                    maxHeight: "30px",
                                                                                                                    marginRight: "5px",
                                                                                                                }}
                                                                                                            // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                                                            // onClick={() =>
                                                                                                            //     handleFileClick(file.file_path)
                                                                                                            // }
                                                                                                            />
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <span className="d-flex rafilename">
                                                                                                                <img src={Docmnt} className="fileimg" />
                                                                                                            </span>
                                                                                                        </>
                                                                                                    )}
                                                                                                    <span className="rafilename">
                                                                                                        {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                                                                    </span>
                                                                                                    <button
                                                                                                        className="msg_download"
                                                                                                        type="button"
                                                                                                        onClick={() =>
                                                                                                            handleDownload(file.file_path, file.file_name)
                                                                                                        }
                                                                                                    >
                                                                                                        <FontAwesomeIcon icon={faFileArrowDown} />
                                                                                                    </button>
                                                                                                </div>
                                                                                            </>
                                                                                        );
                                                                                    })}
                                                                                </div>
                                                                            }
                                                                        </Accordion.Body>
                                                                    </Accordion.Item>
                                                                </Accordion>
                                                            </>
                                                        ))}
                                                    </div>
                                                    <div>
                                                        <Form.Group className='massge_text'>
                                                            <div className='mag_send'>
                                                                <Link to='#' onClick={handleBrowseFiles}> <FontAwesomeIcon icon={faPaperclip} /> </Link>
                                                                {/* <Button variant="primary" onClick={() => sendMessage(selectedButton)} ><FontAwesomeIcon icon={faPaperPlane} /></Button> */}
                                                                {/* <button className='btn btn-primary drpbtn'>Browse Files</button> */}
                                                                <input
                                                                    type="file"
                                                                    ref={fileInputRef}
                                                                    style={{ display: 'none' }}
                                                                    onChange={(e) => handleFileChange(e, 'R')}
                                                                    multiple
                                                                />
                                                            </div>
                                                            <div className='d-flex reco_image'>
                                                                {rfiles.map((file, index) => {
                                                                    const fileName = file?.file_name;
                                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                    const extension = fileName?.split(".").pop();
                                                                    return (
                                                                        <div key={index} className='img-thumbnail'>
                                                                            {file?.type?.startsWith('image/') ? (
                                                                                <img
                                                                                    // src={URL.createObjectURL(file)}
                                                                                    src={file.base64}
                                                                                    alt="Preview"
                                                                                    style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                                                />
                                                                            ) : (
                                                                                <span className=''><img src={Docmnt} className='fileimg' />  </span>
                                                                            )}
                                                                            <span className="rafilename">
                                                                                {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                                            </span>
                                                                            <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index, 'R')}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                            <div>
                                                                <Form.Control
                                                                    as="textarea"
                                                                    placeholder='Enter a description...'
                                                                    rows={2}
                                                                    name='message'
                                                                    onChange={conversationChange}
                                                                    value={sendData?.message || ''}
                                                                // disabled={isSwitchOn === true}
                                                                />
                                                            </div>
                                                        </Form.Group>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    {/* {selectedButton === 'tmanage' &&
                                        <TaskManagement data={formData} />
                                    }
                                    {selectedButton === 'dmanage' &&
                                        <DocManagement data={formData} />
                                    }
                                    {selectedButton === 'invoice' &&
                                        <Invoice data={formData} />
                                    } */}
                                </Col>
                                <Col sm='3'>
                                    <div className='flbg mb-3'>
                                        <div className='d-flex justify-content-between align-items-center up_reco'>
                                            <div className='up_reco_left'>
                                                <h4>Airline</h4>
                                                <p>Campus Airline</p>
                                            </div>
                                            <div>
                                                <span>{formData?.total_traced_pieces}/{formData?.pieces_involved}</span>
                                            </div>
                                            <div>
                                                <Button onClick={updateRecovery}>Update Recovery</Button>
                                            </div>

                                        </div>

                                    </div>
                                    {formData?.stations?.map((station, index) => (
                                        <div className='flbg mb-3'>
                                            <div className='d-flex justify-content-between align-items-center up_reco_status'>
                                                <div className='reco_left'>
                                                    <h4>{station.station_name}</h4>
                                                    <p>{station.handler_name}</p>
                                                </div>
                                                <div className='reco_middle'>
                                                    <span className={station.pieces_traced == null ? '' : station.pieces_traced == formData.pieces_involved ? 'serv_trace_gr' : 'serv_trace_org'}>
                                                        {station.pieces_traced == null ? 'No Response' : station.pieces_traced == formData.pieces_involved ? 'All Completed' : `${station.pieces_traced}/${formData.pieces_involved} Pieces Traced`}</span>

                                                </div>
                                                <div className='reco_right'>
                                                    {/* <Link><FontAwesomeIcon icon={faEye} /></Link> */}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    {/* <div className='flbg mb-3'>

                                        <div className='d-flex justify-content-between align-items-center up_reco_status'>
                                            <div className='reco_left'>
                                                <h4>AEE</h4>
                                                <p>World Flight Services MAIN</p>
                                            </div>
                                            <div className='reco_middle'>
                                                <span>4/10 Pieces traced</span>
                                            </div>
                                            <div className='reco_right'>
                                                <Link></Link>
                                            </div>

                                        </div>

                                    </div> */}
                                    <div className='missing_info recover_right'>
                                        <div className='mb-3'>
                                            <h4>Highlighted Image(s)</h4>
                                            {formData?.attachments && (
                                                <div className='main_primary'>
                                                    {findPrimary.map((file, index) => {
                                                        const fileName = file?.file_name;
                                                        // console.log("🚀 ~ {files.map ~ file:", file)
                                                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                        const extension = fileName?.split(".").pop();
                                                        return (
                                                            <>
                                                                <div key={`ns_${index}`} className='primary_image'>
                                                                    {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                                    ) ? (
                                                                        <div>
                                                                            <img
                                                                                src={file.file_path}
                                                                                alt="Preview"
                                                                                style={{
                                                                                    maxWidth: "100%",
                                                                                    maxHeight: "100%",

                                                                                }}
                                                                                // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                                onClick={() =>
                                                                                    handleImageClick(file.file_path)
                                                                                }
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            <span className="">
                                                                                <img src={Docmnt} className="fileimg" />
                                                                            </span>
                                                                        </>
                                                                    )}
                                                                    <span className="rafilename">
                                                                        {baseName?.length <= 5 ? fileName : `${baseName?.substring(0, 5)}... .${extension}`}
                                                                    </span>
                                                                    {/* <Link to="/" className="slide_dwnldbtn" onClick={() => handleDownload(file.file_path, file.file_name)}>
                                                                                    <FontAwesomeIcon icon={faDownload} />
                                                                                </Link> */}

                                                                    {/* {1 === 1 && ( */}
                                                                    {/* {file.is_comment !== 1 &&
                                                                            file.is_editable === 1 && ( */}
                                                                    {/* <button
                                                                            className="dltbtn"
                                                                            type="button"
                                                                            onClick={() =>
                                                                                handleDeleteImage(index, file.id, file.attachment_type)
                                                                            }
                                                                        >
                                                                            <FontAwesomeIcon icon={faCircleXmark} />
                                                                        </button> */}
                                                                    {/* )} */}
                                                                </div>
                                                            </>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                        <hr />
                                        <h4>Recovery Information</h4>
                                        <ul>
                                            <li>
                                                <span>Master Airway Bill :</span> <span> {formData?.master_airway_bill_prefix} - {formData?.master_airway_bill_no}</span>
                                            </li>
                                            <li>
                                                <span>Flight Number :</span> <span> {formData?.flight_prefix} - {formData?.flight_no}</span>
                                            </li>
                                            <li>
                                                <span>Flight Date :</span> <span> {formData?.flight_date}</span>
                                            </li>
                                            <li>
                                                <span>Origin :</span> <span> {formData?.origin}</span>
                                            </li>
                                            <li>
                                                <span>Origin Handler :</span> <span> {formData?.origin_handler_name}</span>
                                            </li>
                                            <li>
                                                <span>Destination :</span> <span> {formData?.destination}</span>
                                            </li>
                                            <li>
                                                <span>Destination Handler :</span> <span> {formData?.destination_handler_name}</span>
                                            </li>
                                        </ul>
                                        <hr />
                                        <h4>Incident Information</h4>
                                        <ul>
                                            <li>
                                                <span>Total MAWB Pieces :</span> <span> {formData?.total_mawb_pieces}</span>
                                            </li>
                                            <li>
                                                <span>Weight (Kg) :</span> <span> {formData?.total_mawb_wght}</span>
                                            </li>
                                            <li>
                                                <span>Pieces involved :</span> <span> {formData?.pieces_involved}</span>
                                            </li>
                                            <li>
                                                <span>Involved Weight (Kg) :</span> <span> {formData?.pieces_wght}</span>
                                            </li>
                                            <li>
                                                <span>Recovery Aspects :</span> <span> {formData?.recovery_aspects_text}</span>
                                            </li>
                                            <li>
                                                <span>Status :</span> <span> {formData?.status}</span>
                                            </li>
                                            <li>
                                                <span>Comment :</span> <span> {formData?.comment}</span>
                                            </li>

                                        </ul>
                                    </div>
                                </Col>
                            </Row>
                        </div>

                    </div>
                </div>
            </div >

            <Modal show={confModal} onHide={closeConfirm} className="addfrom change_type" centered>
                <Modal.Header closeButton onClick={closeConfirm}></Modal.Header>
                <Modal.Body>
                    <h3>The Attachment will be deleted. </h3>
                    <p>Are you sure you want to continue?</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-75 mx-auto are_bottom">
                        <Button variant="secondary" onClick={closeConfirm}> No</Button>
                        <Button variant="primary" onClick={handleConfirmation}> Yes </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={closeRecModal} onHide={closeRecModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>Recovery Information</h3>
                    <p>Are you sure you want to {recStat == 'c' ? 're-open' : 'close'} recovery?</p>
                    <div className='missing_info'>
                        {/* <h4>ULD Information</h4>
                        <p>Overview of ULD Specifications</p> */}
                        <ul>
                            <li>
                                <span>Master Airway Bill</span> <span>:   {formData?.master_airway_bill_prefix} {formData?.master_airway_bill_no}</span>
                            </li>
                            <li>
                                <span>Total Pieces</span> <span>:   {formData?.total_mawb_pieces}</span>
                            </li>
                            <li>
                                <span>Pieces Involved</span> <span>:   {formData?.pieces_involved}</span>
                            </li>
                            <li>
                                <span>Pieces Traced</span> <span>:   {formData?.total_traced_pieces}</span>
                            </li>
                            <li>
                                <span>Flight Number</span> <span>:   {formData?.flight_no}</span>
                            </li>
                            <li>
                                <span>Origin</span> <span>:  {formData?.origin}</span>
                            </li>
                            <li>
                                <span>Origin Handler</span> <span>:  {formData?.origin_handler_name}</span>
                            </li>
                            <li>
                                <span>Destination</span> <span>:  {formData?.destination}</span>
                            </li>
                            <li>
                                <span>Destination Handler</span> <span>:  {formData?.destination_handler_name}</span>
                            </li>
                        </ul>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-75 mx-auto are_bottom">
                        <Button variant="secondary" className='position-relative' onClick={closeRecModalClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" className='position-relative' onClick={confirmCloseRecovery}>
                            {recStat == 'c' ? 'Re-Open' : 'Close'} Recovery
                        </Button>
                    </div>

                </Modal.Footer>
            </Modal>
            <Modal show={imgShow} onHide={handleClose} centered className="imgmodal" size='lg'>
                <Modal.Header closeButton onClick={handleClose}></Modal.Header>
                <Modal.Body className='text-center'>
                    {/* {console.log(selectedFile)} */}
                    <img src={highlightedFile} className="img-fluid" alt="Selected" />

                </Modal.Body>
            </Modal>
            <Modal show={addressModalShow} onHide={addressModalClose} centered className='addfrom'>
                <Modal.Header closeButton onClick={addressModalClose}>
                    <Modal.Title>{addressFor == 'OH' || addressFor == 'DH' || addressFor == 'SH' ? 'Edit' : 'Add'} Address - {addressFor == 'origin' || addressFor == 'OH' ? orgLabel : (addressFor == 'destination' || addressFor == 'DH' ? destLabel : getDestination.find(nm => nm.station_id === selectedStation?.station_id)?.label)}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form.Group className='mb-2'>
                        <Form.Label>Handler Name <span>*</span></Form.Label>
                        {/* <Form.Control type="text" onChange={handleAddressChange} name='company_name' placeholder="Company Name" /> */}
                        <Select
                            options={handlerList}
                            onChange={(selected) => {
                                setInputAddress(prevFormData => {
                                    const newFormData = { ...prevFormData, handler_org_id: selected.value }; // , handler_email_id: selected.email 
                                    return newFormData;
                                });
                            }}
                            placeholder="Select Handler"
                            className='select_handler'
                            name='handler_org_id'
                            value={handlerList.find(option => option.value === inputAddress.handler_org_id) || ''}
                        />
                    </Form.Group>

                    <Form.Group className='mb-2'>
                        <Form.Label>Email ID  <Link to="#" className="raad_adrss" onClick={addEmailField}>+ Add Email</Link></Form.Label>
                        {/* <Form.Control type="text" onChange={handleAddressChange} name='handler_email_id' placeholder="E-mail" value={inputAddress.handler_email_id || ''} /> */}
                        {inputAddress?.handler_email_id?.map((email, index) => (
                            <div key={index} className="d-flex align-items-center position-relative mb-2">
                                <Form.Control
                                    type="text"
                                    placeholder="E-mail"
                                    value={email}
                                    onChange={(e) => handleEmailChange(index, e.target.value)}
                                    className=""
                                />
                                {inputAddress.handler_email_id.length > 1 && (

                                    <Link to="#" onClick={() => removeEmailField(index)} className="email_del"> <FontAwesomeIcon icon={faCircleXmark} /> </Link>

                                )}
                            </div>
                        ))}
                    </Form.Group>

                    <Form.Group className='mb-2'>
                        <Form.Label>Address </Form.Label>
                        <Form.Control type="text" onChange={handleAddressChange} name='address' placeholder="Address" value={inputAddress.address || ''} />
                    </Form.Group>


                    <Form.Group className='mb-2'>
                        <Form.Label>Telephone No</Form.Label>
                        <Form.Control
                            type="number"
                            onChange={handleAddressChange}
                            name='handler_phone_no'
                            onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12); }}
                            placeholder="Number"
                            value={inputAddress.handler_phone_no || ''}
                        />
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={addAddress}  >
                        {addressFor == 'OH' || addressFor == 'DH' || addressFor == 'SH' ? 'Update' : 'Add'} Address
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AddRecovery;